class CustomDetails extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.summary = this.querySelector("[data-summary]");
    this.content = this.querySelector("[data-content]");
    this.toggle = this.querySelector("[data-toggle]");

    this.summary?.addEventListener("click", (e) => {
      this.isOpen ? this.close() : this.open();
    });

    this.toggle?.addEventListener("click", () => {
      this.isOpen ? this.close() : this.open();
    });

    if (this.summary) {
      this.summary.setAttribute("aria-expanded", "false");
    }
  }

  _forceOpen() {
    this.removeEventListener("transitionend", this.handleTransitionEnd);
    this.setAttribute("open", "");
    this.content.style.height = null;
    this.content.style.opacity = null;
  }

  _forceClosed() {
    this.removeEventListener("transitionend", this.handleTransitionEnd);
    this.removeAttribute("open");
    this.content.style.height = null;
    this.content.style.opacity = null;
  }

  get isOpen() {
    return this.hasAttribute("open");
  }

  open() {
    if (this.isOpen) return;
    this.removeEventListener("transitionend", this.handleTransitionEnd);
    this.setAttribute("open", "");
    this.summary.setAttribute("aria-expanded", "true");
    // if (this.hasAttribute('focus-toggle-on-open') && this.toggle) {
    //   this.toggle.focus();
    // }

    if (this.content) {
      this.content.style.height = 0;
      this.content.style.opacity = 0;

      window.requestAnimationFrame(() => {
        this.content.style.height = `${this.content.scrollHeight}px`;
        this.content.style.opacity = 1;
      });
    }
  }

  close() {
    if (!this.isOpen) return;
    if (this.content) {
      this.removeEventListener("transitionend", this.handleTransitionEnd);

      this.handleTransitionEnd = () => {
        this.removeEventListener("transitionend", this.handleTransitionEnd);
        this.removeAttribute("open");
        this.summary.setAttribute("aria-expanded", "false");
        // if (this.hasAttribute('focus-toggle-on-open') && this.toggle) {
        //   this.summary.focus();
        // }
      };

      this.addEventListener("transitionend", this.handleTransitionEnd);

      this.content.style.height = 0;
      this.content.style.opacity = 0;
    } else {
      this.removeAttribute("open");
      this.summary.setAttribute("aria-expanded", "false");
    }
  }
}

if (!customElements.get("custom-details")) {
  customElements.define("custom-details", CustomDetails);
}
